import { CustomCellEditorProps } from 'ag-grid-react';
import { IOriginDatasetTableContext } from 'FeatureModules/DataImport/Components/Forms/DatasetValidation';
import WktGeometryEditorDialog from 'FeatureModules/DataImport/Components/DIalogs/WktGeometryEditorDialog';
import { EDatasetColumn } from 'FeatureModules/DataImport/types/dataset.types';
import React, { FC } from 'react';

const GeometryCellEditor: FC<
  CustomCellEditorProps<unknown, string, IOriginDatasetTableContext>
> = ({ value, context, onValueChange, stopEditing }) => {
  if (context.settings?.columns.geometry?.format !== EDatasetColumn.GEOMETRY_WKT) {
    throw new Error('GeometryCellEditor should only be used for WKT geometry format');
  }
  return (
    <WktGeometryEditorDialog
      open={true}
      value={value}
      onSave={onValueChange}
      onClose={stopEditing}
    />
  );
};

export default GeometryCellEditor;
